<template>
    <div class="make-payment">
        <table v-if="order">
            <tr>
                <td>
                    <strong>{{ $t('order.customer') }}:</strong>
                </td>
                <td>{{ order.customer }}</td>
            </tr>
            <tr>
                <td>
                    <strong>{{ $t('order.invoice_no') }}:</strong>
                </td>
                <td>{{ order.invoice_no }}</td>
            </tr>
            <tr>
                <td>
                    <strong>{{ $t('order.invoice_date') }}:</strong>
                </td>
                <td>{{ order.invoice_date }}</td>
            </tr>
            <tr>
                <td>
                    <strong>{{ $t('order.shipping_method') }}:</strong>
                </td>
                <td>{{ order.ship_method.name[$i18n.locale] }}</td>
            </tr>
            <tr>
                <td>
                    <strong>{{ $t('order.payment_method') }}:</strong>
                </td>
                <td>{{ order.pay_method.name[$i18n.locale] }}</td>
            </tr>
            <tr>
                <td>
                    <strong>{{ $t('order.order_price') }}:</strong>
                </td>
                <td>{{ order.total }} {{ order.currency.iso }}</td>
            </tr>
            <tr>
                <td colspan="2">
                    <hr />
                </td>
            </tr>
            <tr>
                <td colspan="2">
                    <table class="order-products">
                        <thead>
                        <tr>
                            <td>
                                <strong>{{ $t('order.product') }}</strong>
                            </td>
                            <td>
                                <strong>{{ $t('order.sku') }}</strong>
                            </td>
                            <td width="100">
                                <strong>{{ $t('order.qty') }}</strong>
                            </td>
                            <td width="100">
                                <strong>{{ $t('order.price') }}</strong>
                            </td>
                            <td width="100">
                                <strong>{{ $t('order.total') }}</strong>
                            </td>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-for="product in order.products" :key="product.id">
                            <td>
                                <router-link :to="$i18nRoute({name: 'product', params: {product: product.id}})">
                                    {{
                                    product.pivot.name
                                    }}
                                </router-link>
                            </td>
                            <td>{{ product.pivot.sku }}</td>
                            <td>{{ product.pivot.quantity }}</td>
                            <td>{{ product.pivot.price }} {{ order.currency.iso }}</td>
                            <td>
                                {{ product.pivot.price * product.pivot.quantity }}
                                {{ order.currency.iso }}
                            </td>
                        </tr>
                        </tbody>
                        <tfoot>
                        <tr>
                            <td colspan="2"></td>
                            <td colspan="3">
                                <table>
                                    <tr>
                                        <td>{{ $t('order.subtotal') }}</td>
                                        <td>{{ order.subtotal }} {{ order.currency.iso }}</td>
                                    </tr>
                                    <tr v-if="order.total_shipping > 0">
                                        <td>{{ $t('order.shipping') }}</td>
                                        <td>{{ order.total_shipping }} {{ order.currency.iso }}</td>
                                    </tr>
                                    <tr v-if="order.total_discount > 0">
                                        <td>{{ $t('order.discount') }}</td>
                                        <td>{{ order.total_discount }} {{ order.currency.iso }}</td>
                                    </tr>
                                    <tr v-if="order.total_coupon > 0">
                                        <td>{{ $t('order.coupon') }}</td>
                                        <td>{{ order.total_coupon }} {{ order.currency.iso }}</td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <strong>{{ $t('order.grand_total') }}</strong>
                                        </td>
                                        <td>{{ order.grand_total }} {{ order.currency.iso }}</td>
                                    </tr>
                                </table>
                            </td>
                        </tr>
                        </tfoot>
                    </table>
                </td>
            </tr>
            <tr>
                <td colspan="2">
                    <hr />
                </td>
            </tr>
            <tr>
                <td>
                    <h2>{{ $t('order.billing_address') }}</h2>
                    <table>
                        <tr>
                            <td>
                                <strong>{{ $t('order.name') }}</strong>
                            </td>
                            <td>
                                {{ order.billing_address.first_name }}
                                {{ order.billing_address.last_name }}
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <strong>{{ $t('order.address') }}</strong>
                            </td>
                            <td>
                                {{ order.billing_address.address_1 }}
                                <span
                                        v-if="order.billing_address.address_2 != ''"
                                >
                    <br />
                    {{ order.billing_address.address_2 }}
                  </span>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <strong>{{ $t('order.country') }}</strong>
                            </td>
                            <td>{{ order.billing_address.country.name }}</td>
                        </tr>
                        <tr>
                            <td>
                                <strong>{{ $t('order.city') }}</strong>
                            </td>
                            <td>{{ order.billing_address.city }}</td>
                        </tr>
                        <tr>
                            <td>
                                <strong>{{ $t('order.postal_code') }}</strong>
                            </td>
                            <td>{{ order.billing_address.zip_code }}</td>
                        </tr>
                        <tr>
                            <td>
                                <strong>{{ $t('order.phone') }}</strong>
                            </td>
                            <td>{{ order.billing_address.phone }}</td>
                        </tr>
                        <tr>
                            <td>
                                <strong>{{ $t('order.email') }}</strong>
                            </td>
                            <td>{{ order.billing_address.email }}</td>
                        </tr>
                    </table>
                </td>
                <td>
                    <h2>{{ $t('order.shipping_address') }}</h2>
                    <table>
                        <tr>
                            <td>
                                <strong>{{ $t('order.name') }}</strong>
                            </td>
                            <td>
                                {{ order.shipping_address.first_name }}
                                {{ order.shipping_address.last_name }}
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <strong>{{ $t('order.address') }}</strong>
                            </td>
                            <td>
                                {{ order.shipping_address.address_1 }}
                                <span
                                        v-if="order.shipping_address.address_2 != ''"
                                >
                    <br />
                    {{ order.shipping_address.address_2 }}
                  </span>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <strong>{{ $t('order.country') }}</strong>
                            </td>
                            <td>{{ order.shipping_address.country.name }}</td>
                        </tr>
                        <tr>
                            <td>
                                <strong>{{ $t('order.city') }}</strong>
                            </td>
                            <td>{{ order.shipping_address.city }}</td>
                        </tr>
                        <tr>
                            <td>
                                <strong>{{ $t('order.postal_code') }}</strong>
                            </td>
                            <td>{{ order.shipping_address.zip_code }}</td>
                        </tr>
                        <tr>
                            <td>
                                <strong>{{ $t('order.phone') }}</strong>
                            </td>
                            <td>{{ order.shipping_address.phone }}</td>
                        </tr>
                    </table>
                </td>
            </tr>
        </table>

        <div class="buttons" v-if="order.status.slug=='waiting-to-payment' && order.grand_total != '0.00'">
            <button class="button" @click="make_payment()">ԿԱՏԱՐԵԼ ՎՃԱՐՈՒՄ</button>
        </div>
    </div>
</template>

<script>
  import Api from '@/services/api-service'
  export default {
    name: 'make-payment',
    data () {
      return {
        order: false
      }
    },
    created () {
      if(this.$route.params.action){
        this.getOrder()
      }else{
        this.$router.push(this.$i18nRoute({name: 'my-account', params: {page: 'orders'}}))
      }
    },
    methods: {
      getOrder () {
        Api.post('getorder', {
          user_id: this.$store.state.auth.user.id,
          order_id: this.$route.params.action
        })
          .then(response => {
            this.order = response.data.order
          })
          .catch(error => {
            console.log(error)
          })
      },
      make_payment () {
        if(this.order.status.slug === 'waiting-to-payment' && this.order.grand_total != '0.00') {
          Api.post('make-payment', {
            order_id: this.$route.params.action
          })
            .then(response => {
              if (response.data.status === 'success') {
                window.location.href = response.payment_response.payment_url
              }
            })
            .catch(error => {
              console.log(error)
            })
        }
      }
    }
  }
</script>

<style lang="scss">
    .make-payment {
        table{
            width: 100%;
            border-collapse: collapse;
            td{
                padding-top: 5px;
                padding-bottom: 5px;
                font-size: 14px;
            }
        }
        .buttons{
            text-align: center;
            margin-top: 30px;
        }
    }
</style>
